<template>
  <section class="content_container plan_confirm">
    <div class="thank_you">
      <div class="img text-center thank-img-container">
        <img :src="thankYouImage ? thankYouImage : defaultImage" alt="Corenroll">
      </div>
      <div class="content mt-3">
        <!-- <h1>
          <span class="head_grey">Thank you for choosing our</span><br>Insurance Plans.
        </h1> -->
        <div class="eligibility-container mb-3 mt-2">
          <h4 class="mb-1">Effective Date</h4>
          <div class="eligibility-text" v-for="eff in effective" :value="eff" :key="eff"><span> Your coverage will begin on <strong>{{eff}}</strong></span></div>
        </div>
        <div class="eligibility-container mb-2 mt-2">
          <h4 class="mb-1">Eligibility Requirement</h4>
          <div class="eligibility-text"><span>Please confirm whether each individual being enrolled is either a <strong> U.S. citizen</strong> or <strong>a green card holder.</strong></span></div>
         </div>
        <div class="eligibility-checkbox mb-3">
          <div class="checkbox-option">
            <input
                type="checkbox"
                id="eligibilityYes"
                :checked="eligibilityConfirmed === 'yes'"
                @change="handleCheckboxChange('yes', $event)"
                class="checkbox-input"
            >
            <label for="eligibilityYes" class="eligibility-label">Yes</label>
          </div>
          <div class="checkbox-option">
            <input
                type="checkbox"
                id="eligibilityNo"
                :checked="eligibilityConfirmed === 'no'"
                @change="handleCheckboxChange('no', $event)"
                :class="{ 'checked-no': eligibilityConfirmed === 'no' }"
                class="checkbox-input"
            >
            <label for="eligibilityNo" class="eligibility-label">No</label>
          </div>
        </div>
        <div v-if="eligibilityConfirmed === 'no'" class="mb-3 error-message">
          <i class="fa fa-exclamation-circle"></i>
          Enrollment is only available to U.S. citizens or permanent residents.
        </div>
        <div class="proceed-btn text-center">
          <button class="back me-0" type="button" id="backCart" name="button" @click="navigatePrevious">Back to Cart</button>
          <button class="proceed" type="button" id="beginEnroll" :disabled="eligibilityConfirmed !== 'yes'"  :class="{ 'disabled-btn': eligibilityConfirmed !== 'yes' }"
                  name="button" @click="nextPage">Proceed to Enrollment</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// import axios from 'axios';
export default {
  name: "EligibilityConfirmation",
  props: {
    effective: Array,
  },
  data() {
    return {
      eligibilityConfirmed: null,
      tempId: window.localStorage.getItem('tempId'),
      thankYouImage: 'https://corenroll-logo.s3.us-east-2.amazonaws.com/enrollment-complete-bg.png',
      defaultImage: ''
    }
  },
  computed: {
    getLandingUrl () {
      return this.$store?.getters?.getLandingUrl
    }
  },
  mounted() {
    let app = this;
    app.tempId = window.localStorage.getItem('tempId');
    app.fetchCatchInfo();
  },
  methods: {
    handleCheckboxChange(value, event) {
      if (event.target.checked) {
        this.eligibilityConfirmed = value;
      } else {
        this.eligibilityConfirmed = null;
      }
    },
    nextPage: function() {
      if (this.eligibilityConfirmed !== 'yes') {
        return;
      }
      this.$emit('Checkoutcart');
      localStorage.setItem('enrollment','new_enrollment');
      if (this.getLandingUrl) {
        this.$router.push(`/${this.getLandingUrl}/enrollment/personal-info`)
      } else {
        this.$router.push('enrollment/personal-info');
      }
    },
    navigatePrevious: function() {
      this.$emit('hidePopUp');
    },
    fetchCatchInfo() {
      let siteDomain = window.btoa(unescape(encodeURIComponent(process.env.VUE_APP_SITE_DOMAIN)))
      // let siteDomain = 'aHR0cHM6Ly9lbnJvbGwucHVyZW5yb2xsLmNvbQ=='
      let url = `${process.env.VUE_APP_API_BASE}/get-external-site-dynamic-information?site_domain=${siteDomain}`
      caches.open('fetch_color_cache').then((cache) => {
        cache.match(url).then(response => {
          response.json().then(data => {
            let getCatchColor = []
            let newObj = {}
            getCatchColor = data
            getCatchColor.map(item => {
              newObj[item.key] = item.value;
            });
            this.defaultImage = newObj["VUE_APP_THANK_YOU"]
          })
        })
      }).catch((err) => {
        console.log(err);
      })
    }
  }
}
</script>

<style src="../assets/css/confirm_eligibility.css">
</style>